import * as Yup from 'yup';
import GuidedTour from './GuidedTour';
import CardEditTemplate from './CardEditTemplate';
import isMobilePhone from 'validator/lib/isMobilePhone';
import isEmail from 'validator/lib/isEmail';
import Input from './Input';
import ContactsFields from './ContactsFields';
import { userUpdate } from '../utils/firebase';
import { useFirebase } from './FirebaseContextProvider';
import { wrapProfileUpdate } from '../utils/misc';
import placeholderPerson from '../assets/images/placeholder-person.png';

const steps = [
  {
    target: '.field-manager-card-edit',
    title: 'Personal information',
    content: 'Fill in your personal information first to access the app',
  },
];

export default function FieldManagerCardEdit({ manager }) {
  const {
    id,
    name,
    phone,
    email = '',
    emailConsent,
    smsConsent,
  } = manager;

  const { userIsFieldManager, user } = useFirebase();
  const isOwnProfile = user?.id === id;

  const initialValues = {
    name: name || '',
    phone: phone || '',
    email: email || '',
    emailConsent: name ? emailConsent : true,
    smsConsent: name ? smsConsent : true,
  };

  const validationSchema = new Yup.ObjectSchema({
    name: Yup.string().max(100, 'Too long').required('Required'),
    phone: Yup.string()
      .required('Required')
      .test('is-valid-phone', 'Invalid', (value) =>
        value ? isMobilePhone(value, 'en-US', { strictMode: false }) : false,
      ),
    email: Yup.string()
      .test('is-valid-email', 'Invalid', (value) => isEmail(value))
      .required('Required'),
  });

  return (
    <GuidedTour
      steps={userIsFieldManager ? steps : []}
      tourKey='field-manager-card-edit-v1'
    >
      <CardEditTemplate
        className='field-manager-card-edit'
        showUploadWarning
        id={id}
        imgPath={manager.imgPath}
        imgThumbPath={manager.imgThumbPath}
        hasImage={!!manager.imgPath}
        placeholder={placeholderPerson}
        formConfig={{
          initialValues,
          validationSchema,
        }}
        update={wrapProfileUpdate(userUpdate, isOwnProfile)}
        create={() => {}}
        afterCreateNavPath={`/field-managers/${id}#tournaments`}
      >
        {(formik) => (
          <>
            <Input
              name='name'
              placeholder='Name'
              {...formik.getFieldProps('name')}
              error={
                formik.touched.name && formik.errors.name
                  ? formik.errors.name
                  : null
              }
            />
            <ContactsFields
              formik={formik}
              emailDisabled
              consentDisabled={!isOwnProfile}
            />
          </>
        )}
      </CardEditTemplate>
    </GuidedTour>
  );
}
